import { GoPerson, GoFile, GoPeople, GoGear, GoBlocked } from "react-icons/go";
import { ROLES } from "../../config/roles";

export const getMenuItems = (currentRole, canEditRoles, canViewTenders) => {
  const baseItems = [
    {
      icon: <GoPerson />,
      title: "My Profile",
      path: "/profile",
    },
    {
      icon: <GoFile />,
      title: "Documents manager",
      path: "/documents",
    },
    {
      icon: <GoPeople />,
      title: "My Contacts",
      path: "/contacts",
    },
  ];

  // Add Roles & Responsibilities for users with edit_roles permission
  if (currentRole === ROLES.ClubAdmin && canEditRoles) {
    baseItems.push({
      icon: <GoGear />,
      title: "Roles & Responsibilities",
      path: "/club/roles",
    });
  }

  // Banned Agents — the club settings entry for the silent agent ban. Gated on
  // the SAME permission as Club Tenders (`view_tenders`), per PART A of the
  // pitch-lifecycle work order: "every club member who has access to Club
  // Tenders — the same permission gates this menu". Staff and Coach are
  // included deliberately: they are club members with a Tenders surface, and
  // the rule names club MEMBERSHIP, not the admin seat.
  if (
    [ROLES.ClubAdmin, ROLES.Staff, ROLES.Coach].includes(currentRole) &&
    canViewTenders
  ) {
    baseItems.push({
      icon: <GoBlocked />,
      title: "Banned Agents",
      path: "/club/banned-agents",
    });
  }

  return baseItems;
};
